<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          `The Retire/Merge ID panel displays the "ID to Retire" and the "ID to Merge To" 
          form. Manually add the ID to Retire and the ID to Merge To. Double check the ID 
          numbers to be sure you have entered the IDs correctly. Click the Submit button 
          and review the data on the subsequent page`,
        ],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
